import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Skeleton,
} from "@mui/material";
import {
  People,
  CheckCircle,
  Cancel,
  AdminPanelSettings,
  VerifiedUser,
  PersonAdd,
} from "@mui/icons-material";
import { SPACING, BORDER_RADIUS, ICON_SIZES } from "../../theme/constants";
import { flexCenter } from "../../theme/responsive";

const StatCard = ({ title, value, icon: Icon, color, loading }) => {
  return (
    <Card
      sx={{
        height: "100%",
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `1px solid ${color}30`,
      }}
    >
      <CardContent>
        <Box sx={{ ...flexCenter, mb: SPACING.xs }}>
          <Box
            sx={{
              p: SPACING.xs,
              borderRadius: BORDER_RADIUS.md,
              backgroundColor: `${color}20`,
              ...flexCenter,
              mr: SPACING.sm,
            }}
          >
            <Icon sx={{ color, fontSize: ICON_SIZES.lg }} />
          </Box>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {title}
          </Typography>
        </Box>
        {loading ? (
          <Skeleton variant="text" width={80} height={40} />
        ) : (
          <Typography variant="h4" fontWeight={700} sx={{ color }}>
            {value !== null && value !== undefined ? value : "—"}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

const UserStatsCards = ({ stats, loading }) => {
  const statCards = [
    {
      title: "Total Users",
      value: stats?.totalUsers,
      icon: People,
      color: "#1976d2",
    },
    {
      title: "Active Users",
      value: stats?.activeUsers,
      icon: CheckCircle,
      color: "#2e7d32",
    },
    {
      title: "Inactive Users",
      value: stats?.inactiveUsers,
      icon: Cancel,
      color: "#d32f2f",
    },
    {
      title: "Admin Users",
      value: stats?.adminUsers,
      icon: AdminPanelSettings,
      color: "#ed6c02",
    },
    {
      title: "Verified Users",
      value: stats?.verifiedUsers,
      icon: VerifiedUser,
      color: "#0288d1",
    },
    {
      title: "Recent Users",
      value: stats?.recentUsers,
      icon: PersonAdd,
      color: "#9c27b0",
    },
  ];

  if (loading && !stats) {
    return (
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={item}>
            <Card>
              <CardContent>
                <Skeleton variant="text" width="60%" height={24} />
                <Skeleton
                  variant="text"
                  width="40%"
                  height={48}
                  sx={{ mt: 1 }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {statCards.map((stat, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={index}>
          <StatCard
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            color={stat.color}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default UserStatsCards;
